export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521221/GoncaKaranfil/goncakapak42.jpg'
];